<template>
  <teleport to="body">
    <div v-if="modelValue" class="modal-overlay" :class="{ fullscreen }">
      <div class="modal-content" :class="{ 'is-fullscreen': fullscreen }" @click.stop>
        <slot :closeModal="handleClose"></slot>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import { defineProps, defineEmits, provide } from 'vue'

defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  fullscreen: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'close'])

// Предоставляем функцию закрытия дочерним компонентам
provide('closeModal', () => {
  emit('update:modelValue', false)
  emit('close')
})
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  position: relative;
  width: 100%;
  max-width: 48rem; /* ~768px */
  background: white;
  border-radius: 12px;
  overflow-y: auto;
  max-height: 90vh;
  margin: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.modal-content.is-fullscreen {
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100vh;
  border-radius: 0;
  margin: 0;
}

/* Мобильная адаптивность */
@media (max-width: 768px) {
  .modal-overlay {
    padding: 12px;
    align-items: center;
  }
  
  .modal-content {
    border-radius: 12px;
    width: 100%;
    height: auto;
    max-height: calc(100vh - 24px);
    overflow-y: auto;
  }
  
  .modal-overlay.fullscreen {
    padding: 0;
    align-items: stretch;
  }
  .modal-content.is-fullscreen {
    border-radius: 0;
    width: 100vw;
    height: 100vh;
    max-height: 100vh;
  }
}

@media (max-width: 480px) {
  .modal-overlay {
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
  }
}
</style>
